export default {
      id: "nav-home-filled-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#nav-home-filled",
      toString: function () {
        return this.url;
      }
    }